<script setup lang="ts">
import {
  BellOutlined,
  MenuUnfoldOutlined,
  SearchOutlined,
  UserOutlined,
  LogoutOutlined,
} from "@ant-design/icons-vue";
import {
  LayoutHeader,
  Button,
  Input,
  Badge,
  Dropdown,
  Menu,
  MenuItem,
  Avatar,
  Tooltip,
} from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { useDefaultLayout } from "../composables/useDefaultLayout";
import { useHeader } from "../composables/useHeader";
import { useSidebar } from "../composables/useSidebar";
import LanguageToggle from "./LanguageToggle.vue";
import ThemeToggle from "./ThemeToggle.vue";

const { t } = useI18n();
const { goToProfile, handleSearch, search, userInitials } = useHeader();
const { logout } = useSidebar();
const { isMobile, toggleMobileSidebar } = useDefaultLayout();
</script>

<template>
  <LayoutHeader class="crm-header">
    <div class="crm-header__left">
      <Button
        v-if="isMobile"
        type="text"
        class="crm-header__menu-button"
        :aria-label="t('menu.toggle_sidebar')"
        @click="toggleMobileSidebar"
      >
        <template #icon>
          <MenuUnfoldOutlined />
        </template>
      </Button>
      <Input
        v-model:value="search"
        class="crm-global-search"
        :placeholder="t('common.search')"
        allow-clear
        @press-enter="handleSearch"
      >
        <template #prefix><SearchOutlined /></template>
      </Input>
    </div>

    <div class="crm-header__actions">
      <LanguageToggle />
      <ThemeToggle />
      <Tooltip :title="t('common.notifications')">
        <Button
          type="text"
          shape="circle"
          :aria-label="t('common.notifications')"
        >
          <Badge dot><BellOutlined /></Badge>
        </Button>
      </Tooltip>
      <Dropdown
        overlay-class-name="crm-user-dropdown"
        placement="bottomRight"
        :trigger="['click']"
      >
        <Button
          type="text"
          class="crm-user-trigger"
          :aria-label="t('common.profile')"
        >
          <Avatar :size="30">{{ userInitials }}</Avatar>
        </Button>
        <template #overlay>
          <Menu>
            <MenuItem key="profile" @click="goToProfile">
              <template #icon><UserOutlined /></template>
              {{ t("common.profile") }}
            </MenuItem>
            <MenuItem key="logout" danger @click="logout">
              <template #icon><LogoutOutlined /></template>
              {{ t("auth.logout") }}
            </MenuItem>
          </Menu>
        </template>
      </Dropdown>
    </div>
  </LayoutHeader>
</template>
